export interface SrpVersion {
  name: string;
  url: string;
  tooltip?: string;
}

export interface Product {
  id: string;
  name: string;
  description: string;
  icon: 'ivms' | 'aims' | 'cris-wildfire' | 'cris-storm';
  srpVersions: SrpVersion[];
}

export const products: Product[] = [
  {
    id: 'ivms',
    name: 'IVMS',
    description: 'Intelligent Vegetation Management System',
    icon: 'ivms',
    srpVersions: [
      { name: 'IVMS 3.2.0', url: 'https://ivms-demo-2.aidash.io/' },
      { name: 'IVMS 2.6.1', url: 'https://ivms-demo.aidash.io/' }
    ],
  },
  {
    id: 'aims',
    name: 'AIMS',
    description: 'Asset Inspection and Monitoring System',
    icon: 'aims',
    srpVersions: [
      { name: 'AIMS 1.0', url: 'https://ivms-demo-asset360.aidash.io/' },
    ],
  },
  {
    id: 'cris-wildfire',
    name: 'CRIS for Wildfire',
    description: 'Climate Risk Intelligence System for Wildfire Mitigation',
    icon: 'cris-wildfire',
    srpVersions: [
      { name: 'Premium 3.0', url: 'https://aidashcorp.app.aidash.io/' },
      { name: 'Essential 3.0', url: 'https://crisessential.app.aidash.io/' },
    ],
  },
  {
    id: 'cris-storm',
    name: 'CRIS for Storm',
    description: 'Climate Risk Intelligence System for Storm Resilience',
    icon: 'cris-storm',
    srpVersions: [
      { name: 'Storm 1.0', url: 'https://cris-demo.aidash.io/' },
    ],
  },
];
